/**
 * Where to go after signing in: `?next=` from the sign-in link.
 *
 * Only a path on this site is accepted — `/p/123`, never `//evil.example`,
 * `https://evil.example` or `/\evil.example`. Whitespace is refused outright: browsers
 * strip tabs and newlines from URLs, so `/<tab>/evil.example` would pass a check for
 * "starts with one slash" and then be followed as `//evil.example`.
 */
export function safeNext(value: string | null): string {
  if (!value?.startsWith('/') || value.startsWith('//')) return '/';
  if (value.includes('\\') || /\s/.test(value)) return '/';
  return value;
}
